import { useEffect, useState } from 'react'
import { Collapse } from 'antd'
import { useSelector } from 'react-redux'
import { changeHistoryApi, ChangeHistoryRow } from '@/api/changeHistory'
import HistoryTable from '@pages/Admin/Reports/ChangeHistory/HistoryTable'
import { useAddAlert } from '@/hooks/useAddAlert'
import PrimaryButton from '@pages/Admin/CourseSettings/components/PrimaryButton/PrimaryButton'

const ProfileHistory = ({ userId }: { userId: number }) => {
  const configuredLimit = Number(
    useSelector((store: any) => store.settings.changeHistoryProfileLimit) ?? 100
  )
  const limit =
    Number.isInteger(configuredLimit) &&
    configuredLimit >= 1 &&
    configuredLimit <= 1000
      ? configuredLimit
      : 100
  const [open, setOpen] = useState(false)
  const [rows, setRows] = useState<ChangeHistoryRow[]>([])
  const [loading, setLoading] = useState(false)
  const [revision, setRevision] = useState(0)
  const addAlert = useAddAlert()
  useEffect(() => {
    if (!open) return
    let active = true
    setLoading(true)
    changeHistoryApi
      .user(userId)
      .then((response: any) => {
        if (active) setRows(response?.data?.data || [])
      })
      .catch(() => {
        if (active)
          addAlert({
            type: 'error',
            text: 'Не удалось загрузить изменения профиля',
          })
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [userId, open, revision, limit, addAlert])
  return (
    <Collapse onChange={(keys) => setOpen(keys.length > 0)}>
      <Collapse.Panel
        key="history"
        header={`Изменения профиля — последние ${limit} записей`}
      >
        <PrimaryButton
          onClick={() => setRevision((value) => value + 1)}
          disabled={loading}
        >
          Обновить историю
        </PrimaryButton>
        <HistoryTable rows={rows} loading={loading} />
      </Collapse.Panel>
    </Collapse>
  )
}

export default ProfileHistory
